module.exports = {
  newSearchAndFolderView: 'assignment_new_search_and_folder_view',
  lcbOpenSection: 'lock_sections_lcb_open_section_button',
  switchAccountView: 'switch_account_view',
  dashboardToggle: 'dashboard_toggle',
  newDashboardOverviewSteps: 'new_dashboard_overview_steps',
  itemDetailsChangeQuestionType: 'item_details_change_question_type',
  nyMathInlineMathEssayConversion: 'ny_math_inline_math_essay_conversion',
  teacherCommonDistrictSetting: 'teacher_common_dsitrict_setting',
  assignmentSettingsChanges: 'assignment_settings_changes',
  testInstructionsMultilanguage: 'test_instructions_multilanguage',
  pearyChatbot: 'peary_chatbot',
  profileReportsJoyrideVisit1: 'profile_reports_joyride_visit_1',
  profileReportsJoyrideVisit2: 'profile_reports_joyride_visit_2',
  actionHubJoyride: 'action_hub_joyride',
}
